const KEY = "sf_recent_files";

export function rememberFile({ case_id, name, sf, path }) {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || "[]").filter((f) => f.case_id !== case_id);
    list.unshift({ case_id, name, sf, path, at: Date.now() });
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12)));
  } catch { /* storage unavailable */ }
}

export function recentFiles() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}
